class CartCountController {
    constructor($scope, $rootScope, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.service = CartService;
        this.count = 0;
    }
}

let cartCountComponent = {
    bindings: {
        count: '@'
    },
    template: `
        <span ng-if="$ctrl.service.loaded">{{ $ctrl.service.items.length }}</span>
        <span ng-if="!$ctrl.service.loaded">{{ $ctrl.count }}</span>`,
    controller: CartCountController
}

export default cartCountComponent;